import React from 'react';
import Page from '../../layout/Page';
import { useParams } from 'react-router-dom';
import { QuestRoute } from '../../api/QuestRoutes';
import Loading from '../../Loading';
import GetState from '../../GetState';
import Management from './LoyaltyAccount/Management';
import Table from '../../table/Table';
import { formatCurrency, generateId, shortHandDateTime } from '../../utility/functions';
import LinkTo from '../../forms/LinkTo';
import Button from '../../forms/Button';
import Invoices from '../reporting/sales/Invoices';
import { userRoles } from '../../RoleProtected';
import ModalFactory from '../../Modal';
import ExpressPassForm from '../../processors/ExpressPassForm';
import KioskErrorResponses from '../reporting/KioskErrorResponses';

export const LoyaltyUserContext = React.createContext();

const LoyaltyUser = ({ ...props }) => {

    const { loyaltyAccountId } = useParams();

    const [user, refreshUser] = GetState(QuestRoute.loyaltyUser.info(loyaltyAccountId));

    if (!user) return <Loading page />;

    if (user.error) return <div>{user.errorMessage}</div>

    const contextValues = {
        user,
        refreshUser,
    }

    const addMember = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Add Member',
            body: (<ExpressPassForm parent={user.loyaltyAccountId} billingCycle={user.billingCycle} refresh={refreshUser} id={id} />)
        })
    }
    const showCustomPrice = () => {
        var hasCustom = true;
        user.members.forEach(member => {
            if(member.loyaltyType != 'DailyPass' && member.loyaltyType != 'FleetPass')
                hasCustom = false;            
        })
        return hasCustom;                    
    }

    return (
        <LoyaltyUserContext.Provider value={contextValues}>
            <Page
                title={user.accountName}
                tabs
            >
                <Management tab='User Management' />

                <Table
                    tab='Members'
                    config={{
                        data: user.members ?? [],
                        label: 'Members',
                        controls: [<Button onClick={addMember}>Add Member</Button>],
                        disableHeaderSearch: true,
                        headers: 
                        (showCustomPrice()) ? 
                        [
                            {
                                label: 'Contact Name',
                                propKey: 'name',
                            }, {
                                label: 'Status',
                                propKey: 'status',
                            }, {
                                label: 'Loyalty Type',
                                propKey: 'loyaltyType',
                            }, {
                                label: 'Award Name',
                                propKey: 'awardName',
                            }, {
                                label: 'Package Price',
                                propKey: 'packagePrice',
                                type: 'number'
                            },
                            {
                                label: 'Custom Price',
                                propKey: 'customPrice',
                                type: 'number'
                            },
                            {
                                label: 'Last Activity',
                                propKey: 'lastActivity',
                            },
                        ] : 
                        [
                            {
                                label: 'Contact Name',
                                propKey: 'name',
                            }, {
                                label: 'Status',
                                propKey: 'status',
                            }, {
                                label: 'Loyalty Type',
                                propKey: 'loyaltyType',
                            }, {
                                label: 'Award Name',
                                propKey: 'awardName',
                            }, {
                                label: 'Package Price',
                                propKey: 'packagePrice',
                                type: 'number'
                            },
                            {
                                label: 'Last Activity',
                                propKey: 'lastActivity',
                            },
                        ],
                        renderFormat: (e) => (
                            <tr key={generateId()}>
                                <td>
                                    <LinkTo
                                        // target='_blank'
                                        to={'/loyaltyMember/' + e.memberId}
                                    >
                                        {e.name}
                                    </LinkTo>
                                </td>
                                <td>{e.status}</td>
                                <td>{e.loyaltyType}</td>
                                <td>{e.awardName}</td>
                                <td>{formatCurrency(e.packagePrice)}</td>
                                {(showCustomPrice()) && <td>{formatCurrency(e.customPrice)}
                                </td>}
                                <td>{shortHandDateTime(e.lastActivity)}</td>
                            </tr>
                        )
                    }}
                />

                <Invoices
                    tab='Invoices'
                    endpoint={QuestRoute.user.invoice(user.customerId)}
                    justReport
                    roles={userRoles.viewAuditReports}
                />

                <KioskErrorResponses 
                    tab='Error Responses' 
                    parentPage='LoyaltyUser'
                    dataRoute={QuestRoute.loyaltyUser.kioskErrorResponseLog(user.loyaltyAccountId)}
                    roles={userRoles.viewUsageReports} 
                />

            </Page >
        </LoyaltyUserContext.Provider>
    );
}

export default LoyaltyUser;